import { config } from '@app/config';

export const BLACKFRIDAY_COUNTDOWN_START =
  config?.ENVIRONMENT === 'production'
    ? '2023-11-17T00:00:00-05:00'
    : '2023-10-01T00:00:00-05:00';
export const BLACKFRIDAY_START = '2023-11-24T00:00:00-05:00';
export const BLACKFRIDAY_END = '2023-11-26T23:59:59-05:00';
